// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"PageHeader_mainTitle__14gsO"};